export default __webpack_public_path__ + "static/4-b5630277192f8b65e2d8da3d49edc170.jpeg";